import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { resources } from '../data/programs';

const { FiExternalLink, FiShield, FiInfo } = FiIcons;

const otherLocations = [
  { label: 'Houston', url: 'https://hvacclasseshouston.com' },
  { label: 'Dallas', url: 'https://hvacschoolsdallas.com' },
  { label: 'San Antonio', url: 'https://hvacclassessanantonio.com' },
  { label: 'Phoenix', url: 'https://hvacschoolsphoenix.com' },
  { label: 'Las Vegas', url: 'https://hvacschoolslasvegas.com' },
  { label: 'New York', url: 'https://hvacschoolsnyc.com' },
  { label: 'New Jersey', url: 'https://hvacschoolsnj.com' },
  { label: 'Chicago', url: 'https://hvacschoolschicago.com' },
  { label: 'Florida', url: 'https://hvacschoolsflorida.com' },
];

function Resources() {
  return (
    <footer className="resources">
      <div className="section">
        <div className="section-heading align-left">
          <p className="eyebrow">Trusted references</p>
          <h2>Explore Connecticut HVAC Career Resources</h2>
          <p>
            Use authoritative sources to understand Connecticut licensing,
            certification, energy efficiency, employment outlook, and the
            responsibilities of modern HVAC technicians.
          </p>
          <p>
            Before enrolling, compare official program information with your
            own goals. Ask whether the curriculum includes EPA Section 608
            preparation, electrical troubleshooting, refrigeration fundamentals,
            gas heating, heat pumps, controls, airflow measurement, code
            awareness, and enough hands-on practice.
          </p>
        </div>

        <div className="resource-list">
          {resources.map((resource) => (
            <a href={resource.url} target="_blank" rel="noreferrer" key={resource.title}>
              <span className="resource-icon">
                <SafeIcon icon={FiExternalLink} />
              </span>
              <span>
                <strong>{resource.title}</strong>
                <small>{resource.description}</small>
              </span>
            </a>
          ))}
        </div>

        <div className="disclaimer">
          <SafeIcon icon={FiInfo} />
          <p>
            This independent directory is for educational research. It is not a
            school and does not guarantee admission, employment, licensing,
            certification, or wages. Program availability, pricing,
            credentials, schedules, and licensing requirements can change.
            Verify every important detail directly with the school, the
            Connecticut Department of Consumer Protection, and the relevant
            certification provider.
          </p>
        </div>

        <nav className="location-navigation" aria-label="HVAC schools in other locations">
          <span>View HVAC Schools in Other Locations:</span>
          <div className="location-navigation-links">
            {otherLocations.map((location) => (
              <a
                href={location.url}
                target="_blank"
                rel="noreferrer"
                key={location.label}
              >
                {location.label}
              </a>
            ))}
          </div>
        </nav>

        <div className="footer-bottom">
          <span className="footer-brand">
            <SafeIcon icon={FiShield} />
            <a href="/" aria-label="HVAC Schools Connecticut home page">
              HVAC Schools Connecticut
            </a>
          </span>
          <div className="footer-links">
            <span aria-hidden="true">·</span>
            <a href="/privacy-policy">Privacy Policy</a>
            <span aria-hidden="true">·</span>
            <a href="/sitemap.xml">Sitemap</a>
            <span>© 2026 All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Resources;